<script lang="js">
	export default {
		name: 'BaseDropdownSubmenu'
	};
</script>

<template lang="html">
  <li class="dropdown-submenu">
    <a class="dropdown-item">
      <span><slot name="button-content">Submenu button</slot></span>
      <b-icon-chevron-right />
    </a>
    <ul class="dropdown-menu">
      <!-- default slot -->
      <slot />
    </ul>
  </li>
</template>

<style scoped lang="scss">
	.dropdown-submenu {
		position: relative;

		a:hover ~ .dropdown-menu,
		.dropdown-menu:hover {
			display: block;
		}

		a::after {
			position: absolute;
			transform: rotate(-90deg);
			right: 6px;
			top: 0.8em;
		}

		a.dropdown-item {
			display: flex;
			align-items: center;

			span {
				flex-grow: 1;
			}
		}

		.dropdown-menu {
			display: none;
			position: absolute;
			top: -3.5px;
			margin-top: 0;
			left: 100%;
		}
	}
</style>
